import type { Surface, SidewalkStateItem } from "../types";

export function getSidewalkPlacing(surfaces: Surface[]): string | null {
  if (surfaces.length === 2) return "Both";
  if (surfaces.length === 1) return surfaces[0].style;
  return null;
}

export function getSidewalkStates(subValResult: SidewalkStateItem[] | undefined): { e_state_left: string; e_state_right: string } {
  if (!subValResult || subValResult.length === 0) {
    return { e_state_left: "", e_state_right: "" };
  }

  const indexOfLeft = subValResult.findIndex((item) => item.name === "sd-fpath-left");
  const indexOfRight = subValResult.findIndex((item) => item.name === "sd-fpath-right");

  return {
    e_state_left: indexOfLeft > -1 ? subValResult[indexOfLeft].e_state.toLowerCase() : "",
    e_state_right: indexOfRight > -1 ? subValResult[indexOfRight].e_state.toLowerCase() : "",
  };
}
